import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Modal } from "../../../../../../components/modal";
import { FeedbackModalContainer } from "../style";
import { formatDateTime1 } from "../../../../../../lib/normalizeDate";
import ImageSlider from "../../../../../../components/imageSlider";
import Button from "../../../../../../components/button";
import { AnnouncementAction } from "../../../../../../actions";
import { withRouter } from "react-router-dom";

const AnnouncementModal = ({
  showModal,
  data,
  announcementId,
  closeHandler,
  getAnnouncement
}) => {
  let images = [];
  if (data.path) {
    if (data.path.image) {
      images.push({ id: 1, path: data.path.image });
    }
    if (data.path.gif) {
      images.push({ id: 2, path: data.path.gif });
    }
  }

  useEffect(() => {
    getAnnouncement(announcementId);
  }, []);

  return (
    <FeedbackModalContainer>
      <Modal
        show={showModal}
        height={"auto"}
        closeHandler={closeHandler}
        body={
          data && (
            <div className="response-modal-body-container">
              <div className="response-modal-date">
                {data.created_at && formatDateTime1(data.created_at)}
              </div>
              <div className="response-modal-subject">{data.title}</div>
              <div className="response-modal-title">
                {data.text && data.text.split("\n").join("\n")}
              </div>
              {images && images.length !== 0 && (
                <div className="images">
                  <ImageSlider files={images} />
                </div>
              )}
              <div className="link-button-container">
                {data.button && (
                  <Button
                    btn="primary"
                    onClick={() => window.open(data.button.link, "_blank")}
                  >
                    {data.button.name}
                  </Button>
                )}
              </div>
            </div>
          )
        }
        loading={false}
        header={{}}
      />
    </FeedbackModalContainer>
  );
};

const mapStateToProps = store => {
  return {
    data: store.Announcement.data,
    loading: store.Announcement.loading,
    error: store.Announcement.error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAnnouncement: id => {
      dispatch(AnnouncementAction.getRequest(id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AnnouncementModal));
